// Implement ref https://medium.com/@geekrodion/redux-saga-create-react-app-b6484f704d68
// import _ from 'lodash'

import { createStore, applyMiddleware, compose } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { MODE } from 'x/config/mode'
import { getPersistedState, getPartialStateToSave } from 'x/utils/redux'

import Reactotron from '../utils/reactotronConfig'

import reducers from './reducers'
import middleware from './middleware'
// import { fromJS, Map } from 'immutable'
// import dayjs from 'dayjs'

// const store = createStore(reducers, composeWithDevTools(applyMiddleware(...middleware),  Reactotron.createEnhancer()))
// const store =
//   MODE === 'dev'
//     ? createStore(reducers, composeWithDevTools(applyMiddleware(...middleware)))
//     : createStore(reducers, applyMiddleware(...middleware))

function loadState() {
  try {
    let serialized = localStorage.getItem('appState')
    // console.log('Loading serialized', serialized)
    if (!serialized) return undefined
    // return JSON.parse(serialized)
    serialized = JSON.parse(serialized)
    console.log('Loading state', serialized)

    localStorage.removeItem('appState') // Remove the item after loading

    return serialized
  } catch (e) {
    console.log('Error loading state', e)
    return undefined
  }
}

// function getPersistedState() {
//   try {
//     const loadedState = loadState()

//     // console.log('Loading typeof loadedState.stores.selectedStoreOrdersDates.begin', typeof loadedState.stores.selectedStoreOrdersDates.begin)
//     if (loadedState && loadedState.stores && loadedState.stores.selectedStoreOrdersDates) {
//       const begin = _.isString(loadedState.stores.selectedStoreOrdersDates.begin)
//         ? dayjs(loadedState.stores.selectedStoreOrdersDates.begin)
//         : loadedState.stores.selectedStoreOrdersDates.begin
//       const end = _.isString(loadedState.stores.selectedStoreOrdersDates.end)
//         ? dayjs(loadedState.stores.selectedStoreOrdersDates.end)
//         : loadedState.stores.selectedStoreOrdersDates.end
//       loadedState.stores.selectedStoreOrdersDates.begin = begin
//       loadedState.stores.selectedStoreOrdersDates.end = end
//     }

//     if (loadedState && loadedState.stores && loadedState.stores.selectedStore) {
//       loadedState.stores.selectedStore.isCache = true
//     }
//     console.log('Loading modified state', loadedState)

//     let persistedState = fromJS(loadedState) || Map({})

//     if (loadedState && loadedState.stores && loadedState.stores.selectedStoreOrdersDates) {
//       persistedState = persistedState.setIn(['stores', 'selectedStoreOrdersDates'], {
//         begin: loadedState.stores.selectedStoreOrdersDates.begin,
//         end: loadedState.stores.selectedStoreOrdersDates.end,
//       })
//     }

//     return persistedState
//   } catch (e) {
//     console.log('Error getting persisted state', e)
//     return undefined
//   }
// }

function saveState(state) {
  try {
    // console.log('Saving state', state)
    // const partial = {
    //   profile: state.profile,
    //   stores: state.stores,
    //   mySubScription: state.mySubScription,
    //   subscription: state.subscription,
    // }
    const partial = getPartialStateToSave(state)
    localStorage.setItem('appState', JSON.stringify(partial))
  } catch (e) {
    console.log('Error saving state', e)
  }
}

// โหลด state ที่เคยบันทึกไว้
const persistedState = getPersistedState(loadState())

const enhancers = [applyMiddleware(...middleware)]

if (__DEV__) {
  enhancers.push(Reactotron.createEnhancer())
}

// const store =
//   MODE === 'dev'
//     ? createStore(
//         reducers,
//         persistedState, // inject persisted state ตรงนี้
//         // composeWithDevTools(applyMiddleware(...middleware))
//         composeWithDevTools(applyMiddleware(...middleware))
//       )
//     : createStore(
//         reducers,
//         persistedState, // inject persisted state ตรงนี้
//         applyMiddleware(...middleware)
//       )

const store = createStore(reducers, persistedState, MODE === 'dev' ? composeWithDevTools(...enhancers) : compose(...enhancers))

// subscribe เพื่อ save state ทุกครั้งที่เปลี่ยน
store.subscribe(() => {
  saveState(store.getState().toJS()) // ถ้าใช้ immutable
})

export default store
